<template>
    <div class="area_section" v-if="state.data != null && state.data.length > 0"">
        <div class="area_contents">
            <div class="area_contents_title">
                <p>실인원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">신규 내담자</th>
                            <th scope="col">실인원</th>
                            <th scope="col">1인당 평균 상담건수</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(998, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(999, state.data)) }}</td>
                            <td class="last_line">
                                {{ 
                                    CommonUtils.getCntByCn(999, state.data) === 0
                                        ? 0
                                        : Math.round(CommonUtils.getCntByCn(997, state.data) / CommonUtils.getCntByCn(999, state.data)) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="area_contents">
            <div class="area_contents_title">
                <p>상담유형</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th>전화상담</th>
                            <th>내방상담</th>
                            <th>방문상담</th>
                            <th>사이버</th>
                            <th>서신</th>
                            <th>아웃리치</th>
                            <template v-if="state.sYear >= 2019">
                                <th>온라인 상담</th>
                            </template>
                            <th>총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1, state.data) - CommonUtils.getCntByCn(56, state.data)) }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(2, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(3, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(5, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(95, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(6, state.data)) }}</td>
                            <template v-if="state.sYear >= 2019">
                                <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(620, state.data)) }}</td>
                            </template>
                            <template v-if="state.sYear >= 2019">
                                <td>
                                    {{
                                        CommonUtils.numberFormat(
                                            CommonUtils.getCntByCn(1, state.data) -
                                                CommonUtils.getCntByCn(56, state.data) +
                                                CommonUtils.getCntByCn(2, state.data) +
                                                CommonUtils.getCntByCn(3, state.data) +
                                                CommonUtils.getCntByCn(5, state.data) +
                                                CommonUtils.getCntByCn(95, state.data) +
                                                CommonUtils.getCntByCn(6, state.data) +
                                                CommonUtils.getCntByCn(620, state.data),
                                        )
                                    }}
                                </td>
                            </template>
                            <template v-else>
                                <td>
                                    {{
                                        CommonUtils.numberFormat(
                                            CommonUtils.getCntByCn(1, state.data) -
                                                CommonUtils.getCntByCn(56, state.data) +
                                                CommonUtils.getCntByCn(2, state.data) +
                                                CommonUtils.getCntByCn(3, state.data) +
                                                CommonUtils.getCntByCn(5, state.data) +
                                                CommonUtils.getCntByCn(95, state.data) +
                                                CommonUtils.getCntByCn(6, state.data),
                                        )
                                    }}
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>상담대상자</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th>본인</th>
                            <th>가족/친인</th>
                            <th>동료/이웃</th>
                            <th>타기관</th>
                            <th>성매매방지기관</th>
                            <th>유관기관</th>
                            <th>학교</th>
                            <th>검찰/경찰/법원</th>
                            <th>기타</th>
                            <th>총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(122, state.data) +
                                            CommonUtils.getCntByCn(127, state.data) -
                                            CommonUtils.getCntByCn(56, state.data),
                                    )
                                }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(123, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(124, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(125, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(540, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(541, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(542, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(543, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(126, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(122, state.data) +
                                            CommonUtils.getCntByCn(127, state.data) -
                                            CommonUtils.getCntByCn(56, state.data) +
                                            CommonUtils.getCntByCn(123, state.data) +
                                            CommonUtils.getCntByCn(124, state.data) +
                                            CommonUtils.getCntByCn(125, state.data) +
                                            CommonUtils.getCntByCn(540, state.data) +
                                            CommonUtils.getCntByCn(541, state.data) +
                                            CommonUtils.getCntByCn(542, state.data) +
                                            CommonUtils.getCntByCn(543, state.data) +
                                            CommonUtils.getCntByCn(126, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>상담내용</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th>탈성매매</th>
                            <th>빚문제</th>
                            <th>폭행</th>
                            <th>진로(취업 등)</th>
                            <th>사회적낙인</th>
                            <th>건강의료문제</th>
                            <th>경찰조사</th>
                            <th>법률문제</th>
                            <th>가족문제</th>
                            <th>주거</th>
                            <th>자활문제</th>
                            <th>정서문제</th>
                            <th>사각지대PG</th>
                            <th>기타</th>
                            <th>총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(36, state.data) + CommonUtils.getCntByCn(121, state.data)) }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(37, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(38, state.data) +
                                            CommonUtils.getCntByCn(39, state.data) +
                                            CommonUtils.getCntByCn(40, state.data) +
                                            CommonUtils.getCntByCn(41, state.data) +
                                            CommonUtils.getCntByCn(107, state.data),
                                    )
                                }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(400, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(47, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(570, state.data) +
                                            CommonUtils.getCntByCn(42, state.data) +
                                            CommonUtils.getCntByCn(109, state.data),
                                    )
                                }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(401, state.data) + CommonUtils.getCntByCn(45, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(402, state.data) +
                                            CommonUtils.getCntByCn(44, state.data) +
                                            CommonUtils.getCntByCn(48, state.data) +
                                            CommonUtils.getCntByCn(108, state.data) +
                                            CommonUtils.getCntByCn(46, state.data) +
                                            CommonUtils.getCntByCn(49, state.data) +
                                            CommonUtils.getCntByCn(120, state.data),
                                    )
                                }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(403, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(43, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(563, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(725, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(726, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(50, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(36, state.data) +
                                            CommonUtils.getCntByCn(37, state.data) +
                                            CommonUtils.getCntByCn(38, state.data) +
                                            CommonUtils.getCntByCn(39, state.data) +
                                            CommonUtils.getCntByCn(40, state.data) +
                                            CommonUtils.getCntByCn(41, state.data) +
                                            CommonUtils.getCntByCn(42, state.data) +
                                            CommonUtils.getCntByCn(43, state.data) +
                                            CommonUtils.getCntByCn(563, state.data) +
                                            CommonUtils.getCntByCn(725, state.data) +
                                            CommonUtils.getCntByCn(44, state.data) +
                                            CommonUtils.getCntByCn(45, state.data) +
                                            CommonUtils.getCntByCn(46, state.data) +
                                            CommonUtils.getCntByCn(47, state.data) +
                                            CommonUtils.getCntByCn(48, state.data) +
                                            CommonUtils.getCntByCn(49, state.data) +
                                            CommonUtils.getCntByCn(50, state.data) +
                                            CommonUtils.getCntByCn(107, state.data) +
                                            CommonUtils.getCntByCn(109, state.data) +
                                            CommonUtils.getCntByCn(108, state.data) +
                                            CommonUtils.getCntByCn(120, state.data) +
                                            CommonUtils.getCntByCn(121, state.data) +
                                            CommonUtils.getCntByCn(400, state.data) +
                                            CommonUtils.getCntByCn(401, state.data) +
                                            CommonUtils.getCntByCn(402, state.data) +
                                            CommonUtils.getCntByCn(403, state.data) +
                                            CommonUtils.getCntByCn(570, state.data) +
                                            CommonUtils.getCntByCn(726, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>상담조치결과</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th>정서적지원</th>
                            <th>법률지원</th>
                            <th>의료지원</th>
                            <th>자활지원</th>
                            <th>집단프로그램</th>
                            <th>물적자원</th>
                            <th>심리지원</th>
                            <th>관련기관연계</th>
                            <th>총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(51, state.data)) }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(55, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(54, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(103, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(404, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(405, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(406, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(52, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(51, state.data) +
                                            CommonUtils.getCntByCn(52, state.data) +
                                            CommonUtils.getCntByCn(54, state.data) +
                                            CommonUtils.getCntByCn(55, state.data) +
                                            CommonUtils.getCntByCn(103, state.data) +
                                            CommonUtils.getCntByCn(404, state.data) +
                                            CommonUtils.getCntByCn(405, state.data) +
                                            CommonUtils.getCntByCn(406, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>서비스/자원제공 > 정서지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th>구분</th>
                            <th>일상생활상담</th>
                            <th>가족문제상담</th>
                            <th>경제문제상담</th>
                            <th>정보제공</th>
                            <th>타기관 상담의뢰</th>
                            <th>사부작공방 관련</th>
                            <th>총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(133, state.data)) }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(134, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(135, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(769, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(727, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(800, state.data)) }}</td>

                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(133, state.data) +
                                            CommonUtils.getCntByCn(134, state.data) +
                                            CommonUtils.getCntByCn(135, state.data) +
                                            CommonUtils.getCntByCn(769, state.data) +
                                            CommonUtils.getCntByCn(727, state.data) +
                                            CommonUtils.getCntByCn(800, state.data),
                                    )
                                }}
                            </td>
                        </tr>

                        <tr>
                            <td>구조지원실적</td>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(413, state.data)) }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(414, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(415, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(728, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(729, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(801, state.data)) }}</td>

                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(413, state.data) +
                                            CommonUtils.getCntByCn(414, state.data) +
                                            CommonUtils.getCntByCn(415, state.data) +
                                            CommonUtils.getCntByCn(728, state.data) +
                                            CommonUtils.getCntByCn(729, state.data) +
                                            CommonUtils.getCntByCn(801, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>서비스/자원제공 > 정서지원 > 정보제공</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th>구분</th>
                            <th>경찰·검찰·법원</th>
                            <th>성매매방지기관</th>
                            <th>전문상담기관</th>
                            <th>직업훈련·알선기관</th>
                            <th>1366·1388 등</th>
                            <th>학교·대안교육기관</th>
                            <th>기타</th>
                            <th>총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총 실적</td>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(810, state.data)) }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(811, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(812, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(813, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(814, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(815, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(816, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(810, state.data) +
                                            CommonUtils.getCntByCn(811, state.data) +
                                            CommonUtils.getCntByCn(812, state.data) +
                                            CommonUtils.getCntByCn(813, state.data) +
                                            CommonUtils.getCntByCn(814, state.data) +
                                            CommonUtils.getCntByCn(815, state.data) +
                                            CommonUtils.getCntByCn(816, state.data),
                                    )
                                }}
                            </td>
                        </tr>

                        <tr>
                            <td>구조지원 실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(818, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(819, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(820, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(821, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(822, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(823, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(824, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(818, state.data) +
                                            CommonUtils.getCntByCn(819, state.data) +
                                            CommonUtils.getCntByCn(820, state.data) +
                                            CommonUtils.getCntByCn(821, state.data) +
                                            CommonUtils.getCntByCn(822, state.data) +
                                            CommonUtils.getCntByCn(823, state.data) +
                                            CommonUtils.getCntByCn(824, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>서비스/자원제공 > 정서지원 > 타기관 상담의뢰</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th>구분</th>
                            <th>경찰·검찰·법원</th>
                            <th>성매매방지기관</th>
                            <th>전문상담기관</th>
                            <th>직업훈련·알선기관</th>
                            <th>1366·1388 등</th>
                            <th>학교·대안교육기관</th>
                            <th>기타</th>
                            <th>총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총 실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(730, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(731, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(732, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(733, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(734, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(735, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(736, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(730, state.data) +
                                            CommonUtils.getCntByCn(731, state.data) +
                                            CommonUtils.getCntByCn(732, state.data) +
                                            CommonUtils.getCntByCn(733, state.data) +
                                            CommonUtils.getCntByCn(734, state.data) +
                                            CommonUtils.getCntByCn(735, state.data) +
                                            CommonUtils.getCntByCn(736, state.data),
                                    )
                                }}
                            </td>
                        </tr>

                        <tr>
                            <td>구조지원 실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(738, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(739, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(740, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(741, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(742, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(743, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(744, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(738, state.data) +
                                            CommonUtils.getCntByCn(739, state.data) +
                                            CommonUtils.getCntByCn(740, state.data) +
                                            CommonUtils.getCntByCn(741, state.data) +
                                            CommonUtils.getCntByCn(742, state.data) +
                                            CommonUtils.getCntByCn(743, state.data) +
                                            CommonUtils.getCntByCn(744, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>법률지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th>구분</th>
                            <th scope="col">법률상담</th>
                            <th scope="col">수사동행(경찰)</th>
                            <th scope="col">수사동행(검찰)</th>
                            <th scope="col">수사의뢰</th>
                            <th scope="col">현장구조</th>
                            <th scope="col">소년보호</th>
                            <th scope="col">기타</th>
                            <th scope="col">수사지원</th>
                            <th scope="col">소송지원</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총 실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(136, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(626, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(627, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(139, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(557, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(628, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(629, state.data) + CommonUtils.getCntByCn(141, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(630, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(631, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(136, state.data) +
                                            CommonUtils.getCntByCn(626, state.data) +
                                            CommonUtils.getCntByCn(627, state.data) +
                                            CommonUtils.getCntByCn(139, state.data) +
                                            CommonUtils.getCntByCn(557, state.data) +
                                            CommonUtils.getCntByCn(628, state.data) +
                                            CommonUtils.getCntByCn(629, state.data) +
                                            CommonUtils.getCntByCn(141, state.data) +
                                            CommonUtils.getCntByCn(630, state.data) +
                                            CommonUtils.getCntByCn(631, state.data),
                                    )
                                }}
                            </td>
                        </tr>

                        <tr>
                            <td>구조지원 실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(416, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(671, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(672, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(421, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(558, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(673, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(674, state.data) + CommonUtils.getCntByCn(423, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(675, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(676, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(416, state.data) +
                                            CommonUtils.getCntByCn(671, state.data) +
                                            CommonUtils.getCntByCn(672, state.data) +
                                            CommonUtils.getCntByCn(421, state.data) +
                                            CommonUtils.getCntByCn(558, state.data) +
                                            CommonUtils.getCntByCn(673, state.data) +
                                            CommonUtils.getCntByCn(674, state.data) +
                                            CommonUtils.getCntByCn(423, state.data) +
                                            CommonUtils.getCntByCn(675, state.data) +
                                            CommonUtils.getCntByCn(676, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>법률지원 > 수사지원 > 기소,피소</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th width="15%" colspan="2">구분</th>
                            <th width="15%">기소</th>
                            <th width="15%">피소</th>
                            <th scope="col" width="15%" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2">수사지원</td>
                            <td>총실적</td>

                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(632, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(633, state.data)) }}</td>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(632, state.data) + CommonUtils.getCntByCn(633, state.data)) }}
                            </td>
                        </tr>

                        <tr>
                            <td>구조지원실적</td>

                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(678, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(679, state.data)) }}</td>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(678, state.data) + CommonUtils.getCntByCn(679, state.data)) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>법률지원 > 수사지원 > 선임, 서면, 상담, 증거수집</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th width="15%" colspan="2">구분</th>
                            <th width="15%">선임</th>
                            <th width="15%">서면</th>
                            <th width="15%">상담</th>
                            <th width="15%">증거수집</th>
                            <th scope="col" width="15%" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2">수사지원</td>
                            <td>총실적</td>

                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(635, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(636, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(637, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(638, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(635, state.data) +
                                            CommonUtils.getCntByCn(636, state.data) +
                                            CommonUtils.getCntByCn(637, state.data) +
                                            CommonUtils.getCntByCn(638, state.data),
                                    )
                                }}
                            </td>
                        </tr>

                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(681, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(682, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(683, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(684, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(681, state.data) +
                                            CommonUtils.getCntByCn(682, state.data) +
                                            CommonUtils.getCntByCn(683, state.data) +
                                            CommonUtils.getCntByCn(684, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>법률지원 > 소송지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th width="15%" rowspan="2" colspan="2">구분</th>
                            <th width="15%" colspan="2">민사</th>
                            <th width="15%" colspan="2">형사</th>
                            <th width="15%" colspan="2">가사</th>
                            <th width="15%" colspan="2">행정</th>
                            <th scope="col" width="15%" id="last_th" rowspan="2">총합</th>
                        </tr>
                        <tr>
                            <th>제소</th>
                            <th>피소</th>
                            <th>기소</th>
                            <th>피소</th>
                            <th>제소</th>
                            <th>피소</th>
                            <th>제소</th>
                            <th>피소</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2">소송지원</td>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(645, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(646, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(647, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(648, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(649, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(650, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(651, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(652, state.data)) }}</td>
                            <td scope="col" id="last_td">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(645, state.data) +
                                            CommonUtils.getCntByCn(646, state.data) +
                                            CommonUtils.getCntByCn(647, state.data) +
                                            CommonUtils.getCntByCn(648, state.data) +
                                            CommonUtils.getCntByCn(649, state.data) +
                                            CommonUtils.getCntByCn(650, state.data) +
                                            CommonUtils.getCntByCn(651, state.data) +
                                            CommonUtils.getCntByCn(652, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(691, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(692, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(693, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(694, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(695, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(696, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(697, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(698, state.data)) }}</td>
                            <td scope="col" id="last_td">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(691, state.data) +
                                            CommonUtils.getCntByCn(692, state.data) +
                                            CommonUtils.getCntByCn(693, state.data) +
                                            CommonUtils.getCntByCn(694, state.data) +
                                            CommonUtils.getCntByCn(695, state.data) +
                                            CommonUtils.getCntByCn(696, state.data) +
                                            CommonUtils.getCntByCn(697, state.data) +
                                            CommonUtils.getCntByCn(698, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>법률지원 > 소송지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th width="15%" colspan="3">구분</th>
                            <th width="15%">선임</th>
                            <th width="15%">재판동행</th>
                            <th width="15%">서면</th>
                            <th width="15%">상담</th>
                            <th width="15%">증거수집</th>

                            <th scope="col" width="10%" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="8">소송지원</td>
                            <td rowspan="2">민사</td>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(654, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(655, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(656, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(657, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(717, state.data)) }}</td>

                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(654, state.data) +
                                            CommonUtils.getCntByCn(655, state.data) +
                                            CommonUtils.getCntByCn(656, state.data) +
                                            CommonUtils.getCntByCn(657, state.data) +
                                            CommonUtils.getCntByCn(717, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(700, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(701, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(702, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(703, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(721, state.data)) }}</td>

                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(700, state.data) +
                                            CommonUtils.getCntByCn(701, state.data) +
                                            CommonUtils.getCntByCn(702, state.data) +
                                            CommonUtils.getCntByCn(703, state.data) +
                                            CommonUtils.getCntByCn(721, state.data),
                                    )
                                }}
                            </td>
                        </tr>

                        <tr>
                            <td rowspan="2">형사</td>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(658, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(659, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(660, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(661, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(718, state.data)) }}</td>

                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(658, state.data) +
                                            CommonUtils.getCntByCn(659, state.data) +
                                            CommonUtils.getCntByCn(660, state.data) +
                                            CommonUtils.getCntByCn(661, state.data) +
                                            CommonUtils.getCntByCn(718, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(704, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(705, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(706, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(707, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(722, state.data)) }}</td>

                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(704, state.data) +
                                            CommonUtils.getCntByCn(705, state.data) +
                                            CommonUtils.getCntByCn(706, state.data) +
                                            CommonUtils.getCntByCn(707, state.data) +
                                            CommonUtils.getCntByCn(722, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td rowspan="2">가사</td>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(662, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(663, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(664, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(665, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(719, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(662, state.data) +
                                            CommonUtils.getCntByCn(663, state.data) +
                                            CommonUtils.getCntByCn(664, state.data) +
                                            CommonUtils.getCntByCn(665, state.data) +
                                            CommonUtils.getCntByCn(719, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(708, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(709, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(710, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(711, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(723, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(708, state.data) +
                                            CommonUtils.getCntByCn(709, state.data) +
                                            CommonUtils.getCntByCn(710, state.data) +
                                            CommonUtils.getCntByCn(711, state.data) +
                                            CommonUtils.getCntByCn(723, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td rowspan="2">행정</td>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(666, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(667, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(668, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(669, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(720, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(666, state.data) +
                                            CommonUtils.getCntByCn(667, state.data) +
                                            CommonUtils.getCntByCn(668, state.data) +
                                            CommonUtils.getCntByCn(669, state.data) +
                                            CommonUtils.getCntByCn(720, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(712, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(713, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(714, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(715, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(724, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(712, state.data) +
                                            CommonUtils.getCntByCn(713, state.data) +
                                            CommonUtils.getCntByCn(714, state.data) +
                                            CommonUtils.getCntByCn(715, state.data) +
                                            CommonUtils.getCntByCn(724, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="area_contents">
            <div class="area_contents_title">
                <p>법률지원 > 소송지원 > 민사</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th width="15%" colspan="1">구분</th>

                            <th>손해배상</th>
                            <th>채무부존재</th>
                            <th>청구이의</th>
                            <th>개인파산면책</th>
                            <th>부당이익</th>
                            <th>대여금</th>
                            <th>기타</th>

                            <th scope="col" width="10%" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <!-- <td rowspan="8">소송지원</td> -->
                            <!-- <td rowspan="2">민사</td> -->
                            <td>총실적</td>
                            <!-- <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(654, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(655, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(656, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(657, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(717, state.data)) }}</td> -->
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1000, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1001, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1002, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1003, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1004, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1005, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1006, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        // CommonUtils.getCntByCn(654, state.data) +
                                        //     CommonUtils.getCntByCn(655, state.data) +
                                        //     CommonUtils.getCntByCn(656, state.data) +
                                        //     CommonUtils.getCntByCn(657, state.data) +
                                        //     CommonUtils.getCntByCn(717, state.data) +
                                        CommonUtils.getCntByCn(1000, state.data) +
                                            CommonUtils.getCntByCn(1001, state.data) +
                                            CommonUtils.getCntByCn(1002, state.data) +
                                            CommonUtils.getCntByCn(1003, state.data) +
                                            CommonUtils.getCntByCn(1004, state.data) +
                                            CommonUtils.getCntByCn(1005, state.data) +
                                            CommonUtils.getCntByCn(1006, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <!-- <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(700, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(701, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(702, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(703, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(721, state.data)) }}</td> -->
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1100, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1101, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1102, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1103, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1104, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1105, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1106, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        // CommonUtils.getCntByCn(700, state.data) +
                                        //     CommonUtils.getCntByCn(701, state.data) +
                                        //     CommonUtils.getCntByCn(702, state.data) +
                                        //     CommonUtils.getCntByCn(703, state.data) +
                                        //     CommonUtils.getCntByCn(721, state.data) +
                                        CommonUtils.getCntByCn(1100, state.data) +
                                            CommonUtils.getCntByCn(1101, state.data) +
                                            CommonUtils.getCntByCn(1102, state.data) +
                                            CommonUtils.getCntByCn(1103, state.data) +
                                            CommonUtils.getCntByCn(1104, state.data) +
                                            CommonUtils.getCntByCn(1105, state.data) +
                                            CommonUtils.getCntByCn(1106, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="area_contents">
            <div class="area_contents_title">
                <p>법률지원 > 소송지원 > 형사</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th width="15%" colspan="1">구분</th>

                            <th>성매매</th>
                            <th>사기</th>
                            <th>성폭행/상해</th>
                            <th>주거침입</th>
                            <th>명예훼손</th>
                            <th>협박</th>
                            <th>아청법</th>
                            <th>디지털성범죄</th>
                            <th>기타</th>

                            <th scope="col" width="10%" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>

                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1011, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1012, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1013, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1014, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1015, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1016, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1017, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1018, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1019, state.data)) }}</td>

                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(1011, state.data) +
                                            CommonUtils.getCntByCn(1012, state.data) +
                                            CommonUtils.getCntByCn(1013, state.data) +
                                            CommonUtils.getCntByCn(1014, state.data) +
                                            CommonUtils.getCntByCn(1015, state.data) +
                                            CommonUtils.getCntByCn(1016, state.data) +
                                            CommonUtils.getCntByCn(1017, state.data) +
                                            CommonUtils.getCntByCn(1018, state.data) +
                                            CommonUtils.getCntByCn(1019, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>

                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1111, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1112, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1113, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1114, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1115, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1116, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1117, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1118, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1119, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(1111, state.data) +
                                            CommonUtils.getCntByCn(1112, state.data) +
                                            CommonUtils.getCntByCn(1113, state.data) +
                                            CommonUtils.getCntByCn(1114, state.data) +
                                            CommonUtils.getCntByCn(1115, state.data) +
                                            CommonUtils.getCntByCn(1116, state.data) +
                                            CommonUtils.getCntByCn(1117, state.data) +
                                            CommonUtils.getCntByCn(1118, state.data) +
                                            CommonUtils.getCntByCn(1119, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>의료지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" width="15%">구분</th>
                            <th scope="col">건강상담</th>
                            <th scope="col">내과</th>
                            <th scope="col">산부인과</th>
                            <th scope="col">성형외과</th>
                            <th scope="col">안과/이비인후과</th>
                            <th scope="col">외과</th>
                            <th scope="col">정신건강의학</th>
                            <th scope="col">치과</th>
                            <th scope="col">피부과</th>
                            <th scope="col">종합건강검진</th>
                            <th scope="col">비뇨기과</th>
                            <th scope="col">한방</th>
                            <th scope="col">기타</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(142, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(156, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(157, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(158, state.data)) }}</td>
                            <td>
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(159, state.data) + CommonUtils.getCntByCn(161, state.data)) }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(160, state.data)) }}</td>

                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(162, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(163, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(164, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(165, state.data)) }}</td>

                            <!-- 비뇨기과 -->
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(1165, state.data)) }}</td>

                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(166, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(167, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(142, state.data) +
                                            CommonUtils.getCntByCn(156, state.data) +
                                            CommonUtils.getCntByCn(157, state.data) +
                                            CommonUtils.getCntByCn(158, state.data) +
                                            CommonUtils.getCntByCn(159, state.data) +
                                            CommonUtils.getCntByCn(160, state.data) +
                                            CommonUtils.getCntByCn(161, state.data) +
                                            CommonUtils.getCntByCn(162, state.data) +
                                            CommonUtils.getCntByCn(163, state.data) +
                                            CommonUtils.getCntByCn(164, state.data) +
                                            CommonUtils.getCntByCn(165, state.data) +
                                            CommonUtils.getCntByCn(1165, state.data) +
                                            CommonUtils.getCntByCn(166, state.data) +
                                            CommonUtils.getCntByCn(167, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(427, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(429, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(430, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(431, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(432, state.data) + CommonUtils.getCntByCn(434, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(433, state.data)) }}</td>

                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(435, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(436, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(437, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(438, state.data)) }}</td>

                            <!-- 비뇨기과 -->
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(462, state.data)) }}</td>

                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(439, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(440, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(427, state.data) +
                                            CommonUtils.getCntByCn(429, state.data) +
                                            CommonUtils.getCntByCn(430, state.data) +
                                            CommonUtils.getCntByCn(431, state.data) +
                                            CommonUtils.getCntByCn(432, state.data) +
                                            CommonUtils.getCntByCn(433, state.data) +
                                            CommonUtils.getCntByCn(434, state.data) +
                                            CommonUtils.getCntByCn(435, state.data) +
                                            CommonUtils.getCntByCn(436, state.data) +
                                            CommonUtils.getCntByCn(437, state.data) +
                                            CommonUtils.getCntByCn(438, state.data) +
                                            CommonUtils.getCntByCn(462, state.data) +
                                            CommonUtils.getCntByCn(439, state.data) +
                                            CommonUtils.getCntByCn(440, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>서비스/자원제공 > 자활지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" width="15%">구분</th>
                            <th scope="col">자활상담/정보제공/지원</th>
                            <th scope="col">주거상담/정보제공/지원</th>
                            <th scope="col">자활관련기초검사</th>
                            <th scope="col">직업훈련수당</th>
                            <th scope="col">기타</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(144, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(145, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(146, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(586, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(148, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(144, state.data) +
                                            CommonUtils.getCntByCn(145, state.data) +
                                            CommonUtils.getCntByCn(146, state.data) +
                                            CommonUtils.getCntByCn(586, state.data) +
                                            CommonUtils.getCntByCn(148, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(441, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(442, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(443, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(587, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(444, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(441, state.data) +
                                            CommonUtils.getCntByCn(442, state.data) +
                                            CommonUtils.getCntByCn(443, state.data) +
                                            CommonUtils.getCntByCn(587, state.data) +
                                            CommonUtils.getCntByCn(444, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>서비스/자원제공 > 집단프로그램</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" width="15%">구분</th>
                            <th scope="col">
                                치료회복
                                <br />
                                프로그램
                            </th>
                            <th scope="col">
                                수강명령
                                <br />
                                프로그램
                            </th>
                            <th scope="col">
                                열린터
                                <br />
                                프로그램
                            </th>
                            <th scope="col">
                                예비교육
                                <br />
                                프로그램
                            </th>
                            <th scope="col">
                                심리정서
                                <br />
                                프로그램
                            </th>
                            <th scope="col">
                                사회적응
                                <br />
                                프로그램
                            </th>
                            <th scope="col">
                                사각지대
                                <br />
                                프로그램
                            </th>
                            <th scope="col">문화/체험활동</th>
                            <th scope="col">건강관리/체력강화</th>
                            <th scope="col">기타</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(149, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(150, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(564, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(565, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(571, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(572, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(783, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(573, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(574, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(575, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(149, state.data) +
                                            CommonUtils.getCntByCn(150, state.data) +
                                            CommonUtils.getCntByCn(564, state.data) +
                                            CommonUtils.getCntByCn(565, state.data) +
                                            CommonUtils.getCntByCn(571, state.data) +
                                            CommonUtils.getCntByCn(572, state.data) +
                                            CommonUtils.getCntByCn(783, state.data) +
                                            CommonUtils.getCntByCn(573, state.data) +
                                            CommonUtils.getCntByCn(574, state.data) +
                                            CommonUtils.getCntByCn(575, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(445, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(446, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(566, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(567, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(576, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(577, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(784, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(578, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(579, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(580, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(445, state.data) +
                                            CommonUtils.getCntByCn(446, state.data) +
                                            CommonUtils.getCntByCn(566, state.data) +
                                            CommonUtils.getCntByCn(567, state.data) +
                                            CommonUtils.getCntByCn(576, state.data) +
                                            CommonUtils.getCntByCn(577, state.data) +
                                            CommonUtils.getCntByCn(784, state.data) +
                                            CommonUtils.getCntByCn(578, state.data) +
                                            CommonUtils.getCntByCn(579, state.data) +
                                            CommonUtils.getCntByCn(580, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>서비스/자원제공 > 집단프로그램> 사각지대 프로그램</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" width="15%">구분</th>
                            <th scope="col">사부작공방</th>
                            <th scope="col">사회적응력향상</th>
                            <th scope="col">동료활동</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(748, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(749, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(750, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(748, state.data) +
                                            CommonUtils.getCntByCn(749, state.data) +
                                            CommonUtils.getCntByCn(750, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(752, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(753, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(754, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(752, state.data) +
                                            CommonUtils.getCntByCn(753, state.data) +
                                            CommonUtils.getCntByCn(754, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>서비스/자원제공 > 물적자원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" width="15%">구분</th>
                            <th scope="col">물품</th>
                            <th scope="col">후원금</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(151, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(152, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(151, state.data) + CommonUtils.getCntByCn(152, state.data)) }}</td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(447, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(448, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(447, state.data) + CommonUtils.getCntByCn(448, state.data)) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>서비스/자원연결 > 물적자원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" width="15%">구분</th>
                            <th scope="col">물품</th>
                            <th scope="col">후원금</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(170, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(171, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(170, state.data) + CommonUtils.getCntByCn(171, state.data)) }}</td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(449, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(450, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(449, state.data) + CommonUtils.getCntByCn(450, state.data)) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>서비스/자원연결> 심리지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" width="15%">구분</th>
                            <th scope="col">개별상담</th>
                            <th scope="col">집단상담</th>
                            <th scope="col">임상심리검사</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(168, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(169, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(588, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(168, state.data) +
                                            CommonUtils.getCntByCn(169, state.data) +
                                            CommonUtils.getCntByCn(588, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(451, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(452, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(589, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(451, state.data) +
                                            CommonUtils.getCntByCn(452, state.data) +
                                            CommonUtils.getCntByCn(589, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>타기관의뢰 > 기관유형</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" width="10%">구분</th>
                            <th scope="col">지원시설</th>
                            <th scope="col">공동생활가정</th>
                            <th scope="col">자활지원센터</th>
                            <th scope="col">직업훈련·알선기관</th>
                            <th scope="col">타(성매매)상담소</th>
                            <th scope="col">대안교육위탁기관</th>
                            <th scope="col">일시쉼터</th>
                            <th scope="col">
                                전문상담기관
                                <br />
                                (성폭·가폭·장애인 등)
                            </th>
                            <th scope="col">기타</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(172, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(173, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(174, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(175, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(176, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(177, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(178, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(544, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(179, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(172, state.data) +
                                            CommonUtils.getCntByCn(173, state.data) +
                                            CommonUtils.getCntByCn(174, state.data) +
                                            CommonUtils.getCntByCn(175, state.data) +
                                            CommonUtils.getCntByCn(176, state.data) +
                                            CommonUtils.getCntByCn(177, state.data) +
                                            CommonUtils.getCntByCn(178, state.data) +
                                            CommonUtils.getCntByCn(179, state.data) +
                                            CommonUtils.getCntByCn(544, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(453, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(454, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(455, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(456, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(457, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(458, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(459, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(545, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(460, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(453, state.data) +
                                            CommonUtils.getCntByCn(454, state.data) +
                                            CommonUtils.getCntByCn(455, state.data) +
                                            CommonUtils.getCntByCn(456, state.data) +
                                            CommonUtils.getCntByCn(457, state.data) +
                                            CommonUtils.getCntByCn(458, state.data) +
                                            CommonUtils.getCntByCn(459, state.data) +
                                            CommonUtils.getCntByCn(460, state.data) +
                                            CommonUtils.getCntByCn(545, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>타기관의뢰 > 기관유형> 전문상담기관</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" width="10%">구분</th>
                            <th scope="col">성폭력</th>
                            <th scope="col">가정폭력</th>
                            <th scope="col">장애인</th>
                            <th scope="col">이주여성</th>
                            <th scope="col">디지털성범죄</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>총실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(756, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(757, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(758, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(759, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(760, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(756, state.data) +
                                            CommonUtils.getCntByCn(757, state.data) +
                                            CommonUtils.getCntByCn(758, state.data) +
                                            CommonUtils.getCntByCn(759, state.data) +
                                            CommonUtils.getCntByCn(760, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                        <tr>
                            <td>구조지원실적</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(762, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(763, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(764, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(765, state.data)) }}</td>
                            <td>{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(766, state.data)) }}</td>
                            <td>
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(762, state.data) +
                                            CommonUtils.getCntByCn(763, state.data) +
                                            CommonUtils.getCntByCn(764, state.data) +
                                            CommonUtils.getCntByCn(765, state.data) +
                                            CommonUtils.getCntByCn(766, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>타기관의뢰 > 상담유형</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">의뢰상담</th>
                            <th scope="col">모니터링 상담</th>
                            <th scope="col">입소</th>
                            <th scope="col">이용자 등록</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(310, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(311, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(312, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(313, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(310, state.data) +
                                            CommonUtils.getCntByCn(311, state.data) +
                                            CommonUtils.getCntByCn(312, state.data) +
                                            CommonUtils.getCntByCn(313, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>기타</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">무응답</th>
                            <th scope="col">연락두절</th>
                            <th scope="col">통화거절</th>
                            <th scope="col">행정</th>
                            <th scope="col">종결</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(182, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(183, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(184, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(591, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(770, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(182, state.data) +
                                            CommonUtils.getCntByCn(183, state.data) +
                                            CommonUtils.getCntByCn(184, state.data) +
                                            CommonUtils.getCntByCn(591, state.data) +
                                            CommonUtils.getCntByCn(770, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>성과현황 > 의료지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">치료중단</th>
                            <th scope="col">치료중</th>
                            <th scope="col">완치/증상조절</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(186, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(187, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(188, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(186, state.data) +
                                            CommonUtils.getCntByCn(187, state.data) +
                                            CommonUtils.getCntByCn(188, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>성과현황> 법률지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">승소</th>
                            <th scope="col">패소</th>
                            <th scope="col">보호처분</th>
                            <th scope="col">파산/면책결정</th>
                            <th scope="col">조정/합의</th>
                            <th scope="col">잠정보류</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(189, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(190, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(590, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(191, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(192, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(193, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(189, state.data) +
                                            CommonUtils.getCntByCn(190, state.data) +
                                            CommonUtils.getCntByCn(590, state.data) +
                                            CommonUtils.getCntByCn(191, state.data) +
                                            CommonUtils.getCntByCn(192, state.data) +
                                            CommonUtils.getCntByCn(193, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>성과현황> 자활지원</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">자격증취득</th>
                            <th scope="col">검정고시합격</th>
                            <th scope="col">진학</th>
                            <th scope="col">상위학위취득</th>
                            <th scope="col">학원등록</th>
                            <th scope="col">창업</th>
                            <th scope="col">취업(정규직)</th>
                            <th scope="col">취업(비정규직)</th>
                            <th scope="col">취업(일용직)</th>
                            <th scope="col">취업(기타)</th>
                            <th scope="col">기타</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(194, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(195, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(196, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(197, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(198, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(199, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(200, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(201, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(202, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(203, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(204, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(194, state.data) +
                                            CommonUtils.getCntByCn(195, state.data) +
                                            CommonUtils.getCntByCn(196, state.data) +
                                            CommonUtils.getCntByCn(197, state.data) +
                                            CommonUtils.getCntByCn(198, state.data) +
                                            CommonUtils.getCntByCn(199, state.data) +
                                            CommonUtils.getCntByCn(200, state.data) +
                                            CommonUtils.getCntByCn(201, state.data) +
                                            CommonUtils.getCntByCn(202, state.data) +
                                            CommonUtils.getCntByCn(203, state.data) +
                                            CommonUtils.getCntByCn(204, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>성과현황 > 자활지원 > 취업 및 진학 현황</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">서비스업</th>
                            <th scope="col">생산직</th>
                            <th scope="col">사무직</th>
                            <th scope="col">창업</th>
                            <th scope="col">진학</th>
                            <th scope="col">자격증취득</th>
                            <th scope="col">검정고시합격</th>
                            <th scope="col">상위학위취득</th>
                            <th scope="col">학원등록</th>
                            <th scope="col">진급</th>
                            <th scope="col">기타</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(534, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(535, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(547, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(199, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(196, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(194, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(195, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(197, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(198, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(785, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(204, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(534, state.data) +
                                            CommonUtils.getCntByCn(535, state.data) +
                                            CommonUtils.getCntByCn(547, state.data) +
                                            CommonUtils.getCntByCn(199, state.data) +
                                            CommonUtils.getCntByCn(196, state.data) +
                                            CommonUtils.getCntByCn(194, state.data) +
                                            CommonUtils.getCntByCn(195, state.data) +
                                            CommonUtils.getCntByCn(197, state.data) +
                                            CommonUtils.getCntByCn(198, state.data) +
                                            CommonUtils.getCntByCn(785, state.data) +
                                            CommonUtils.getCntByCn(204, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>성과현황 > 자활지원 > 고용형태</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">정규직</th>
                            <th scope="col">비정규직</th>
                            <th scope="col">인턴,실습</th>
                            <th scope="col">단기간근로자</th>
                            <th scope="col">기타</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(200, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(201, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(536, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(202, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(203, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(200, state.data) +
                                            CommonUtils.getCntByCn(201, state.data) +
                                            CommonUtils.getCntByCn(536, state.data) +
                                            CommonUtils.getCntByCn(202, state.data) +
                                            CommonUtils.getCntByCn(203, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>나이</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">13세이하</th>
                            <th scope="col">14~16세</th>
                            <th scope="col">17~19세</th>
                            <th scope="col">20~29세</th>
                            <th scope="col">30~39세</th>
                            <th scope="col">40~49세</th>
                            <th scope="col">50~59세</th>
                            <th scope="col">60세이상</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(205, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(206, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(207, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(208, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(209, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(210, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(211, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(548, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(212, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(205, state.data) +
                                            CommonUtils.getCntByCn(206, state.data) +
                                            CommonUtils.getCntByCn(207, state.data) +
                                            CommonUtils.getCntByCn(208, state.data) +
                                            CommonUtils.getCntByCn(209, state.data) +
                                            CommonUtils.getCntByCn(210, state.data) +
                                            CommonUtils.getCntByCn(211, state.data) +
                                            CommonUtils.getCntByCn(548, state.data) +
                                            CommonUtils.getCntByCn(212, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>만 나이</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">
                                13세이하
                                <br/>
                                (만 12세 이하)
                            </th>
                            <th scope="col">
                                14~16세
                                <br/>
                                (만 13~15세)
                            </th>
                            <th scope="col">
                                17~19세
                                <br/>
                                (만 16~18세)
                            </th>
                            <th scope="col">
                                20~29세
                                <br/>
                                (만 19~28세)
                            </th>
                            <th scope="col">
                                30~39세
                                <br/>
                                (만 29~38세)
                            </th>
                            <th scope="col">
                                40~49세
                                <br/>
                                (만 39~38세)
                            </th>
                            <th scope="col">
                                50~59세
                                <br/>
                                (만 49~58세)
                            </th>
                            <th scope="col">
                                60세이상
                                <br/>
                                (만 59세 이상)
                            </th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(790, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(791, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(792, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(793, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(794, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(795, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(796, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(797, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(798, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(790, state.data) +
                                            CommonUtils.getCntByCn(791, state.data) +
                                            CommonUtils.getCntByCn(792, state.data) +
                                            CommonUtils.getCntByCn(793, state.data) +
                                            CommonUtils.getCntByCn(794, state.data) +
                                            CommonUtils.getCntByCn(795, state.data) +
                                            CommonUtils.getCntByCn(796, state.data) +
                                            CommonUtils.getCntByCn(797, state.data) +
                                            CommonUtils.getCntByCn(798, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>학력</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">초재</th>
                            <th scope="col">초교중퇴</th>
                            <th scope="col">초교졸</th>
                            <th scope="col">중재</th>
                            <th scope="col">중교중퇴</th>
                            <th scope="col">중교졸</th>
                            <th scope="col">고재</th>
                            <th scope="col">고교중퇴</th>
                            <th scope="col">고교졸</th>
                            <th scope="col">대중퇴</th>
                            <th scope="col">대재</th>
                            <th scope="col">대졸</th>
                            <th scope="col">대학원재</th>
                            <th scope="col">대학원졸</th>
                            <th scope="col">기타</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(592, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(593, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(594, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(595, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(596, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(597, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(598, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(599, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(600, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(601, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(602, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(603, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(604, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(605, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(606, state.data)) }}</td>
                            <td class="last_line">
                                {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(607, state.data) + CommonUtils.getCntByCn(608, state.data)) }}
                            </td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(592, state.data) +
                                            CommonUtils.getCntByCn(593, state.data) +
                                            CommonUtils.getCntByCn(594, state.data) +
                                            CommonUtils.getCntByCn(595, state.data) +
                                            CommonUtils.getCntByCn(596, state.data) +
                                            CommonUtils.getCntByCn(597, state.data) +
                                            CommonUtils.getCntByCn(598, state.data) +
                                            CommonUtils.getCntByCn(599, state.data) +
                                            CommonUtils.getCntByCn(600, state.data) +
                                            CommonUtils.getCntByCn(601, state.data) +
                                            CommonUtils.getCntByCn(602, state.data) +
                                            CommonUtils.getCntByCn(603, state.data) +
                                            CommonUtils.getCntByCn(604, state.data) +
                                            CommonUtils.getCntByCn(605, state.data) +
                                            CommonUtils.getCntByCn(606, state.data) +
                                            CommonUtils.getCntByCn(607, state.data) +
                                            CommonUtils.getCntByCn(608, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>상담경로</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">1366,1388등</th>
                            <th scope="col">117</th>
                            <th scope="col">홍보(인터넷,114,언론보도등)</th>
                            <th scope="col">지인소개</th>
                            <th scope="col">유관기관</th>
                            <th scope="col">성매매방지기관</th>
                            <th scope="col">학교</th>
                            <th scope="col">검찰/경찰/법원</th>
                            <th scope="col">기타</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(609, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(610, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(611, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(612, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(613, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(614, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(615, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(616, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(617, state.data)) }}</td>
                            <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(618, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(609, state.data) +
                                            CommonUtils.getCntByCn(610, state.data) +
                                            CommonUtils.getCntByCn(611, state.data) +
                                            CommonUtils.getCntByCn(612, state.data) +
                                            CommonUtils.getCntByCn(613, state.data) +
                                            CommonUtils.getCntByCn(614, state.data) +
                                            CommonUtils.getCntByCn(615, state.data) +
                                            CommonUtils.getCntByCn(616, state.data) +
                                            CommonUtils.getCntByCn(617, state.data) +
                                            CommonUtils.getCntByCn(618, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>성매매유형</p>
            </div>

            <div class="area_contents_body">
                <template v-if="state.sYear >= 2019">
                    <table class="areaGrid">
                        <thead>
                            <tr>
                                <th scope="col">
                                    (전업형)
                                    <br />
                                    집결지
                                </th>
                                <th scope="col">
                                    (전업형)
                                    <br />
                                    오피스텔
                                </th>
                                <th scope="col">
                                    겸업형
                                    <br />
                                    (기존산업형)
                                </th>
                                <th scope="col">
                                    위장형
                                    <br />
                                    (기존산업형)
                                </th>
                                <th scope="col">출장형</th>
                                <th scope="col">온라인</th>
                                <th scope="col">해외성매매</th>
                                <th scope="col">기타</th>
                                <th scope="col">
                                    기록
                                    <br />
                                    없음
                                </th>
                                <th scope="col" id="last_th">총합</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(220, state.data)) }}</td>

                                <td class="last_line">
                                    {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(621, state.data) + CommonUtils.getCntByCn(561, state.data)) }}
                                </td>

                                <td class="last_line">
                                    {{
                                        CommonUtils.numberFormat(
                                            CommonUtils.getCntByCn(221, state.data) +
                                                CommonUtils.getCntByCn(222, state.data) +
                                                CommonUtils.getCntByCn(223, state.data) +
                                                CommonUtils.getCntByCn(227, state.data) +
                                                CommonUtils.getCntByCn(622, state.data),
                                        )
                                    }}
                                </td>

                                <td class="last_line">
                                    {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(228, state.data) + CommonUtils.getCntByCn(623, state.data)) }}
                                </td>

                                <td class="last_line">
                                    {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(225, state.data) + CommonUtils.getCntByCn(624, state.data)) }}
                                </td>

                                <td class="last_line">
                                    {{
                                        CommonUtils.numberFormat(
                                            CommonUtils.getCntByCn(559, state.data) +
                                                CommonUtils.getCntByCn(560, state.data) +
                                                CommonUtils.getCntByCn(625, state.data),
                                        )
                                    }}
                                </td>

                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(562, state.data)) }}</td>

                                <td class="last_line">
                                    {{ CommonUtils.numberFormat(CommonUtils.getCntByCn(226, state.data) + CommonUtils.getCntByCn(300, state.data)) }}
                                </td>

                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(301, state.data)) }}</td>

                                <td class="last_line">
                                    {{
                                        CommonUtils.numberFormat(
                                            CommonUtils.getCntByCn(220, state.data) +
                                                CommonUtils.getCntByCn(621, state.data) +
                                                CommonUtils.getCntByCn(561, state.data) +
                                                CommonUtils.getCntByCn(221, state.data) +
                                                CommonUtils.getCntByCn(222, state.data) +
                                                CommonUtils.getCntByCn(223, state.data) +
                                                CommonUtils.getCntByCn(227, state.data) +
                                                CommonUtils.getCntByCn(622, state.data) +
                                                CommonUtils.getCntByCn(228, state.data) +
                                                CommonUtils.getCntByCn(623, state.data) +
                                                CommonUtils.getCntByCn(225, state.data) +
                                                CommonUtils.getCntByCn(624, state.data) +
                                                CommonUtils.getCntByCn(559, state.data) +
                                                CommonUtils.getCntByCn(560, state.data) +
                                                CommonUtils.getCntByCn(625, state.data) +
                                                CommonUtils.getCntByCn(562, state.data) +
                                                CommonUtils.getCntByCn(226, state.data) +
                                                CommonUtils.getCntByCn(300, state.data) +
                                                CommonUtils.getCntByCn(301, state.data),
                                        )
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <template v-else>
                    <table class="areaGrid">
                        <thead>
                            <tr>
                                <th scope="col">집결지</th>
                                <th scope="col">
                                    오피스텔
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">식품접객업소</th>
                                <th scope="col">위생접객업소</th>
                                <th scope="col">마사지업소</th>
                                <th scope="col">퐁속영업업소</th>
                                <th scope="col">
                                    변종
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">
                                    전자형성매매
                                    <br />
                                    (조건만남)-개인
                                </th>
                                <th scope="col">
                                    전자형성매매
                                    <br />
                                    (조건만남)-알선
                                </th>
                                <th scope="col">
                                    길거리
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">
                                    출장형
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">외국인전용클럽</th>
                                <th scope="col">
                                    해외
                                    <br />
                                    성매매
                                </th>
                                <th scope="col">기타</th>
                                <th scope="col">
                                    기록
                                    <br />
                                    없음
                                </th>
                                <th scope="col" id="last_th">총합</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(220, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(561, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(221, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(222, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(223, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(227, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(228, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(559, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(560, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(226, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(225, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(224, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(562, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(300, state.data)) }}</td>
                                <td class="last_line">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(301, state.data)) }}</td>
                                <td class="last_line">
                                    {{
                                        CommonUtils.numberFormat(
                                            CommonUtils.getCntByCn(220, state.data) +
                                                CommonUtils.getCntByCn(561, state.data) +
                                                CommonUtils.getCntByCn(221, state.data) +
                                                CommonUtils.getCntByCn(222, state.data) +
                                                CommonUtils.getCntByCn(223, state.data) +
                                                CommonUtils.getCntByCn(227, state.data) +
                                                CommonUtils.getCntByCn(228, state.data) +
                                                CommonUtils.getCntByCn(559, state.data) +
                                                CommonUtils.getCntByCn(560, state.data) +
                                                CommonUtils.getCntByCn(226, state.data) +
                                                CommonUtils.getCntByCn(225, state.data) +
                                                CommonUtils.getCntByCn(224, state.data) +
                                                CommonUtils.getCntByCn(562, state.data) +
                                                CommonUtils.getCntByCn(300, state.data) +
                                                CommonUtils.getCntByCn(301, state.data),
                                        )
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </div>
        </div>

        <div class="area_contents">
            <div class="area_contents_title">
                <p>알선고리</p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col">보도방</th>
                            <th scope="col">소개업자</th>
                            <th scope="col">사채업자</th>
                            <th scope="col">업주</th>
                            <th scope="col">업소관계자</th>
                            <th scope="col">친구,지인</th>
                            <th scope="col">보호자,가족</th>
                            <th scope="col">홍보물</th>
                            <th scope="col">구인구직사이트</th>
                            <th scope="col">채팅앱</th>
                            <th scope="col">기타</th>
                            <th scope="col">기록없음</th>
                            <th scope="col" id="last_th">총합</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(771, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(772, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(773, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(774, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(775, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(776, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(777, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(778, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(779, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(780, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(781, state.data)) }}</td>
                            <td class="">{{ CommonUtils.numberFormat(CommonUtils.getCntByCn(782, state.data)) }}</td>
                            <td class="last_line">
                                {{
                                    CommonUtils.numberFormat(
                                        CommonUtils.getCntByCn(771, state.data) +
                                            CommonUtils.getCntByCn(772, state.data) +
                                            CommonUtils.getCntByCn(773, state.data) +
                                            CommonUtils.getCntByCn(774, state.data) +
                                            CommonUtils.getCntByCn(775, state.data) +
                                            CommonUtils.getCntByCn(776, state.data) +
                                            CommonUtils.getCntByCn(777, state.data) +
                                            CommonUtils.getCntByCn(778, state.data) +
                                            CommonUtils.getCntByCn(779, state.data) +
                                            CommonUtils.getCntByCn(780, state.data) +
                                            CommonUtils.getCntByCn(781, state.data) + 
                                            CommonUtils.getCntByCn(782, state.data),
                                    )
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="area_section" v-else></div>
</template>

<script lang="ts" config>
    import { reactive, onMounted, types, CommonUtils, watch } from "@/BaseComponent";

    export default {
        props: {
            data: { type: Array<types.statistics.StatisticsVOForApi>, default: [] },
            sYear: { type: Number, default: 0 }
        },
        components: {},
        setup(props: any) {
            const state = reactive({
                data: [] as Array<types.statistics.StatisticsVOForApi>,
                sYear: 0 as number,
            });

            onMounted(() => {
                if (props.data) state.data = props.data;
                if (props.sYear && props.sYear > 0) state.sYear = props.sYear;
            });

            watch(props, () => {
                if (props.data) state.data = props.data;
                if (props.sYear && props.sYear > 0) state.sYear = props.sYear;
            });

            return {
                state,
                CommonUtils,
            };
        },
    };
</script>
<style scoped>
    .areaGrid td {
        text-align: center;
    }
</style>
